// tokenStore.ts — tokeny sesji żyją TYLKO w pamięci procesu strony, osobno dla każdego systemu.
//
// Świadomie NIE używamy localStorage/sessionStorage: dowolny XSS odczytuje je natychmiast,
// a Control Center pokazuje dane sprzedażowe i operacyjne.
// Koszt: odświeżenie karty wymaga ponownego logowania — dopóki nie stoimy za TLS-em pod tym
// samym origin co API i nie przejmie tego cookie HttpOnly, które CRM już wystawia.
//
// DŁUG SPŁACONY (ADR-003). Do niedawna Control Center trzymał tyle sesji, ile systemów logowania
// naprawdę istniało — bo przeglądarka logowała się osobno do CRM i osobno do Drive. Dziś sesja
// jest JEDNA: człowiek loguje się do Control Center, a do źródeł chodzi backend tożsamością
// serwisową. Ten magazyn zostaje jako miejsce na tokeny, których aplikacja już nie używa:
// sesja jedzie ciasteczkiem httpOnly, którego skrypt strony nie czyta.

/**
 * Nazwa systemu tożsamości. Świadomie NIE jest już tożsama z systemem API: „crm" i „drive"
 * opisują teraz ŹRÓDŁO DANYCH, a nie miejsce logowania. Zlanie tych dwóch pojęć było dokładnie
 * tym, co pozwalało dwóm sesjom udawać jedną.
 */
export type Realm = 'cc';

export class TokenStore {
  private tokens = new Map<Realm, string>();

  get(realm: Realm): string | null {
    return this.tokens.get(realm) ?? null;
  }

  set(realm: Realm, value: string | null): void {
    if (value === null) this.tokens.delete(realm);
    else this.tokens.set(realm, value);
  }

  clear(realm?: Realm): void {
    if (realm) this.tokens.delete(realm);
    else this.tokens.clear();
  }

  realms(): Realm[] {
    return [...this.tokens.keys()];
  }
}

export const tokenStore = new TokenStore();
